"use strict";

var _slicedToArray = require("/codebuild/output/src490952806/src/github.com/wobicom/wobi-web-auto/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Tooltip = _interopRequireDefault(require("@material-ui/core/Tooltip"));
var _ClickAwayListener = _interopRequireDefault(require("@material-ui/core/ClickAwayListener"));
var _core = require("@material-ui/core");
var _breakpoints = _interopRequireDefault(require("../config/breakpoints"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }
  var cache = _getRequireWildcardCache(nodeInterop);
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj.default = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
var Tooltip = function Tooltip(_ref) {
  var children = _ref.children,
    title = _ref.title,
    name = _ref.name,
    placement = _ref.placement,
    classes = _ref.classes,
    className = _ref.className,
    tooltipProps = _ref.tooltipProps;
  var _ref2 = (0, _react.useState)(false),
    _ref3 = _slicedToArray(_ref2, 2),
    open = _ref3[0],
    setOpen = _ref3[1];
  var isMobile = (0, _core.useMediaQuery)("(max-width:".concat(_breakpoints.default.mobile, "px)"));
  var handleTooltipClose = function handleTooltipClose() {
    setOpen(false);
  };
  var handleTooltip = function handleTooltip() {
    setOpen(!open);
  };
  var events = {};
  if (isMobile) {
    events.onClick = handleTooltip;
    events.open = open;
  }
  var tooltip = /*#__PURE__*/_react.default.createElement(_Tooltip.default, _extends({
    name: name,
    placement: placement,
    classes: classes,
    className: className,
    title: title,
    tabIndex: "0"
  }, events, tooltipProps), children);
  if (isMobile) {
    return /*#__PURE__*/_react.default.createElement(_ClickAwayListener.default, {
      onClickAway: handleTooltipClose
    }, tooltip);
  }
  return tooltip;
};
Tooltip.propTypes = {
  children: _propTypes.default.oneOfType([_propTypes.default.node, _propTypes.default.array, _propTypes.default.string]).isRequired,
  classes: _propTypes.default.object,
  className: _propTypes.default.string,
  name: _propTypes.default.string,
  placement: _propTypes.default.string,
  title: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.node]).isRequired,
  tooltipProps: _propTypes.default.object
};
Tooltip.defaultProps = {
  name: '',
  placement: 'bottom'
};
var _default = exports.default = Tooltip;